export const OFFERING_TYPES: Record<
  string,
  {
    asset_type: string;
    hide_property_type?: boolean;
    hide_target_return?: boolean;
    news_id?: number;
    channel_id?: number;
    page_id: number;
    news_page_id?: number;
    allowFilter?: number;
  }
> = {
  'private-debt': {
    asset_type: 'Private Debt',
    hide_property_type: true,
    hide_target_return: true,
    news_id: 740360,
    page_id: 275870,
    news_page_id: 330212,
  },
  'real-estate': {
    asset_type: 'Real Estate',
    channel_id: 142057,
    hide_property_type: false,
    hide_target_return: false,
    news_id: 16786,
    page_id: 178053,
    news_page_id: 330205,
  },
  startups: {
    asset_type: 'Startups',
    hide_property_type: true,
    hide_target_return: true,
    news_id: 38927,
    page_id: 178043,
    news_page_id: 330214,
  },
};
